import installConfig from './config';
import SouthcnPlugins from 'southcn-ui2/src/plugins';
import { pcModalMap } from './modalDefined';

const {
    installNotify, installStorage, installAlias,
    installStyle, installFilters,
    installImageUtil,
    installBus,
    installMessage,
    installHttp,
    installModal, installUtil
} = SouthcnPlugins;
const injection = {};

export default Object.assign(injection, {

    install (Vue) {
        installHttp(injection, Vue);
        installBus(injection, Vue);
        installConfig(injection, Vue);
        installImageUtil(injection, Vue);
        installStyle(injection, Vue);
        installFilters(injection, Vue);
        installModal(injection, Vue, pcModalMap);
        installNotify(injection, Vue);
        installStorage(injection, Vue);
        installMessage(injection, Vue);
        installAlias(injection, Vue);
        installUtil(injection, Vue);
        window.injection = injection;
    }

});
